import React from "react";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import ContactPageOutlinedIcon from "@mui/icons-material/ContactPageOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import TerminalOutlinedIcon from "@mui/icons-material/TerminalOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";

const iconSx = { fontSize: 20 };

const appointmentMenu = {
  title: "Appointments",
  icon: <EventNoteOutlinedIcon sx={iconSx} />,
  subItems: [
    { title: "My Appointments", link: "/appointments/my" },
    { title: "Calendar", link: "/appointments/calendar" },
    // { title: "Settings", link: "/appointments/settings" },
  ],
};

const appointmentMenuAdminManager = {
  title: "Appointments",
  icon: <EventNoteOutlinedIcon sx={iconSx} />,
  subItems: [
    { title: "All Appointments", link: "/appointments/all" },
    { title: "My Appointments", link: "/appointments/my" },
    { title: "Calendar", link: "/appointments/calendar" },
    { title: "Dashboard", link: "/appointments/dashboard" },
  ],
};

function getSideBarData(role) {
  if (role === "Receptionist") {
    return [
      { title: "Add Enquiry", icon: <PersonAddOutlinedIcon sx={iconSx} />, link: "/create-enquiry" },
      { title: "Enquiry Overview", icon: <ContactPageOutlinedIcon sx={iconSx} />, link: "/all-enquiry" },
      { title: "Application Allocation", icon: <AssignmentTurnedInOutlinedIcon sx={iconSx} />, link: "/application-form-issue" },
      { title: "Assign Counsellor", icon: <PersonAddAltOutlinedIcon sx={iconSx} />, link: "/assign-visa-counsellor" },
      { title: "Exhibition Enquiries", icon: <StorefrontOutlinedIcon sx={iconSx} />, link: "/exhibition-enquiries" },
      // Temporarily disabled
      // appointmentMenu,
    ];
  } else if (role === "Counsellor" ) {
    return [
      { title: "Enquiries", icon: <ContactPageOutlinedIcon sx={iconSx} />, link: "/new-enquiry" },
      { title: "Application Overview", icon: <DescriptionOutlinedIcon sx={iconSx} />, link: "/counsellor-applications" },
      // Temporarily disabled
      // appointmentMenu,
    ];
  } else if ( role === "Visa Counsellor") {
    return [
      { title: "Enquiries", icon: <ContactPageOutlinedIcon sx={iconSx} />, link: "/new-enquiry" },
      // Temporarily disabled
      // appointmentMenu,
    ];
  } else if (role === "Visa&Application Counsellor") {
    return [
      { title: "Enquiries", icon: <ContactPageOutlinedIcon sx={iconSx} />, link: "/new-enquiry" },
      { title: "Application Overview", icon: <DescriptionOutlinedIcon sx={iconSx} />, link: "/counsellor-applications" },
      // Temporarily disabled
      // appointmentMenu,
    ];
  } else if (role === "Manager") {
    return [
      { title: "Create Enquiry", icon: <PersonAddOutlinedIcon sx={iconSx} />, link: "/create-enquiry" },
      { title: "Application Overview", icon: <DescriptionOutlinedIcon sx={iconSx} />, link: "/view-applications" },
      { title: "Application Allocation", icon: <AssignmentTurnedInOutlinedIcon sx={iconSx} />, link: "/application-form-issue" },
      {
        title: "Universities",
        icon: <SchoolOutlinedIcon sx={iconSx} />,
        subItems: [
          { title: "Universities List", link: "/universities/list" },
          { title: "Admin Approval", link: "/universities/approval" },
          // { title: "Reports", link: "/universities/reports" },
        ]
      },
      { title: "Users", icon: <PeopleAltOutlinedIcon sx={iconSx} />, link: "/users" },
      // Temporarily disabled
      // appointmentMenuAdminManager,
    ];
  } else if (role === "admin") {
    return [
      { title: "Dashboard", icon: <SpaceDashboardOutlinedIcon sx={iconSx} />, link: "/home" },
      // { title: "Create Enquiry", icon: <PersonAddOutlinedIcon sx={iconSx} />, link: "/create-enquiry" },
      { title: "Enquiry Overview", icon: <ContactPageOutlinedIcon sx={iconSx} />, link: "/all-enquiry" },
      {
        title: "Marketing",
        icon: <CampaignOutlinedIcon sx={iconSx} />,
        subItems: [
          { title: "Campaigns", link: "/marketing-overview" },
          // { title: "Mediums", link: "/medium-overview" },
          { title: "Medium", link: "/advertising-analysis" },
          { title: "Counsellors", link: "/marketing-counsellor-performance" }
        ]
      },
      {
        title: "Applications",
        icon: <FactCheckOutlinedIcon sx={iconSx} />,
        subItems: [
          { title: "Application Overview", link: "/view-applications" },
          { title: "Form Allocation", link: "/application-form-issue" },
        ]
      },
      {
        title: "Universities",
        icon: <SchoolOutlinedIcon sx={iconSx} />,
        subItems: [
          { title: "Universities List", link: "/universities/list" },
          { title: "Admin Approval", link: "/universities/approval" },
          // { title: "Reports", link: "/universities/reports" },
        ]
      },
      { title: "Exhibition", icon: <StorefrontOutlinedIcon sx={iconSx} />, link: "/exhibition-enquiries" },
      // Temporarily disabled
      // appointmentMenuAdminManager,
      { title: "Users", icon: <PeopleAltOutlinedIcon sx={iconSx} />, link: "/users" },
      {
        title: "Reports",
        icon: <AssessmentOutlinedIcon sx={iconSx} />,
        subItems: [
          { title: "Report Builder", link: "/reports" },
          { title: "Totals", link: "/reports/totals" },
          { title: "Registrations & Visa", link: "/reports/reg-visa-alloc" },
          { title: "Inquiry Sources", link: "/reports/inquiry-source" },
          { title: "Institutes", link: "/reports/institute-conversion" },
        ],
      },
      { title: "Server Logs", icon: <TerminalOutlinedIcon sx={iconSx} />, link: "/server-logs" },
    ];
  }
  return [];
}

export default getSideBarData;
